export const YOUTUBE = 'YOUTUBE'
export const BLOBSTORAGE = 'BLOBSTORAGE'